// extracted by mini-css-extract-plugin
module.exports = {"postPage__box":"postPage_postPage__box__cqE1s","postPage__box_create":"postPage_postPage__box_create__yHDhI","postPage__title":"postPage_postPage__title__OX1RH"};